import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { actions, storeFilterActions } from '@common/redux/modules/Actions';
import { AgencyAppState } from '../../../redux/modules/store';
import StoreSelectModal from '@common/component/organisms/StoreSelectModal';

const mapStateToProps = (appState: AgencyAppState) => {
  return {
    postCd: appState.loginUser.postCd || '',
    stores: appState.loginUser.stores || [],
    targetStores:  appState.storeSelector.targetStores || [],
    filterStores: appState.filterStore,
    isOpen: appState.storeSelector.isModalOpen,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateTargetStore: (selectedStores: string[]) => {
      dispatch(actions.storeSelector.updateSelectedStores(selectedStores));
      dispatch(storeFilterActions.draftFilter.cloneCheckbox())
    },
    updateLocalTargetStore: (selectedStores: string[]) =>{
      dispatch(actions.storeSelector.updateLocalStores(selectedStores));
    },
    onClose: () => {
      dispatch(actions.storeSelector.toggleModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreSelectModal);
